<p-confirmDialog draggable="false" />
<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3 w-full">
    <div class="flex-grow-1">
      <app-primeng-breadcrumb></app-primeng-breadcrumb>
    </div>
    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-content-end">
      <!-- <p-button label="Add Role" (onClick)="openAddProfileModal()" name="plus" permissions resourceName="ROLE" permission="EDIT" [outlined]="false" severity="primary" /> -->
      <p-button *ngIf="isEditPermission" label="Add Role" (onClick)="openAddProfileModal()" [outlined]="false" severity="primary">
        <i-tabler class="ti-normal ti-lg" name="plus"></i-tabler>
      </p-button>
    </div>
  </div>
</div>
<div class="page-content mt-2">
  <app-skeleton id="table-items" *ngIf="loading" [columns]="tableConfig" [paginator]="true"></app-skeleton>
  <div class="table-responsive" *ngIf="!loading">
    <app-primeng-table [tableData]="tableData" [columns]="tableConfig" [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'" [styleClass]="'p-datatable-gridlines'"
      [customTemplates]="{'action': action, 'status': status}">
    </app-primeng-table>
    <ng-template #status let-rowData="rowData" let-index="index">
      <td>
        <span class="font-weight-bold"
          [ngClass]="rowData?.status ? 'text-success':'text-red-500'">{{rowData?.status ? 'Active' : '-'}}</span>
      </td>
    </ng-template>

    <ng-template #action let-rowData="rowData" let-rowIndex="rowIndex">
      <td>
        <div class="flex">
          <p-button *ngIf="isEditPermission" size="small" pTooltip="Edit" (onClick)="handleOptionClick(rowData,'Edit')" [text]="true"
            [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="edit"></i-tabler>
          </p-button>
          <p-button size="small" pTooltip="View" (onClick)="handleOptionClick(rowData,'View')" [text]="true"
            [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="eye"></i-tabler>
          </p-button>
          <p-button *ngIf="isEditPermission" size="small" pTooltip="Delete" (onClick)="handleOptionClick(rowData,'Delete')" [text]="true"
            [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="trash"></i-tabler>
          </p-button>
        </div>
      </td>
    </ng-template>
  </div>
</div>

<p-toast />